import { Tab } from 'semantic-ui-react';

import Carebetty from './carebetty';
import type { CommunicationsProps } from './types';
import Zendesk from './zendesk';
// TODO: Remove connectLog folder once everything's decided
// import ConnectLog from './connectLog';
import Zoom from './zoom';
//import { useAmazonConnect } from 'contexts/AmazonConnectContext';

function Communications(props: CommunicationsProps) {
  //const { setPatient } = useAmazonConnect();
  const patient = props?.patient ?? undefined; //might be redundanant

  /* useEffect(() => {
    setPatient(patient);
  }, [setPatient, patient]); */

  const panes = [
    // ZOOM tab - placed where CONNECT was
    {
      menuItem: {
        key: 'zoom',
        color: 'blue',
        content: 'ZOOM',
        name: 'ZOOM',
      },
      pane: {
        key: 'zoom',
        content: <Zoom flatPatient={patient} />,
      },
    },
    // TODO: Remove connectLog folder once everything's decided
    // disabled while testing connect
    // true
    //   ? {
    //       //amazon connect
    //       menuItem: {
    //         key: 'connect',
    //         color: 'blue',
    //         content: 'CONNECT',
    //         name: 'CONNECT',
    //       },
    //       pane: {
    //         key: 'connect',
    //         content: <ConnectLog flatPatient={patient} />,
    //       },
    //     }
    //   : {},
    patient
      ? {
          menuItem: {
            key: 'carebetty',
            color: 'blue',
            content: 'CAREBETTY',
            name: 'CAREBETTY',
          },
          pane: {
            key: 'carebetty',
            /*
             * SUSPECTED DEFECT — `Carebetty`'s refetch never fires because
             * `activeTab` stops here.
             *
             * `patient/index.tsx` passes `activeTab={props.activeTab}` into this
             * hub, and `Carebetty` opens with
             * `useEffect(() => { if (props.activeTab === 'COMMUNICATION')
             * communicationMutate(); }, [props.activeTab])` — an effect whose
             * whole purpose is to re-fetch the communication log when the user
             * switches to this tab. But this render does not forward it, so
             * inside `Carebetty` `props.activeTab` is permanently `undefined`:
             * the condition is never true and the dependency never changes.
             *
             * LIVE. The log is fetched once when the pane first mounts and then
             * never refreshed, so a practitioner who sends an email or SMS and
             * returns to this tab sees stale data until a full reload. The three
             * sibling tabs are unaffected — only Carebetty has this effect.
             *
             * Not fixed. Adding `activeTab={props.activeTab}` would start firing
             * a network request that does not fire today, which is a behaviour
             * change even though it is very likely the intended one.
             */
            content: <Carebetty patient={patient} />,
          },
        }
      : {},

    patient
      ? {
          menuItem: {
            key: 'zendesk',
            color: 'blue',
            content: 'ZENDESK',
            name: 'ZENDESK',
          },
          pane: {
            key: 'zendesk',
            content: <Zendesk flatPatient={patient} />,
          },
        }
      : {},
  ];

  return (
    <Tab menu={{ secondary: true, pointing: true }} renderActiveOnly={false} panes={panes} defaultActiveIndex={0} />
  );
}

export default Communications;
